import { createFileRoute } from "@tanstack/react-router"
import { meta } from "@/content"
import { Admin } from "@/admin"

export const Route = createFileRoute("/admin")({
  ssr: false,
  component: RouteComponent,
  head: () => ({ meta: meta({ title: "Admin" }) }),
})

function RouteComponent() {
  return <Admin />
}
